import { actionButtonClass, CARD_CLASS } from '../browserStyles';

function ArchesIllustration({ className }: { className?: string }) {
    return (
        <svg
            viewBox="0 0 40 32"
            fill="none"
            strokeLinecap="round"
            className={className}
            aria-hidden="true"
        >
            <g className="text-gray-600" stroke="currentColor" strokeWidth={1.8}>
                <path d="M7 14.5C7 8 12.8 4 20 4s13 4 13 10.5" />
                <path d="M7 17.5C7 24 12.8 28 20 28s13-4 13-10.5" />
            </g>
            <g className="text-gray-500" stroke="currentColor" strokeWidth={1.4}>
                <path d="M12 14.5c0-3.6 3.6-5.8 8-5.8s8 2.2 8 5.8" />
                <path d="M12 17.5c0 3.6 3.6 5.8 8 5.8s8-2.2 8-5.8" />
            </g>
        </svg>
    );
}

// Nothing downloads until Open viewer: the 3D export runs to tens of MB.
export function Scan3dCard({ onOpen }: { onOpen: () => void }) {
    return (
        <section aria-label="3D model" className={`${CARD_CLASS} flex items-center gap-3 p-3.5`}>
            <span className="grid h-[52px] w-16 shrink-0 place-items-center rounded-[10px] bg-gray-100">
                <ArchesIllustration className="h-8 w-10" />
            </span>
            <div className="flex min-w-0 flex-1 flex-col gap-0.5">
                <h5 className="text-[14px] font-semibold text-gray-900">3D model</h5>
                <p className="text-[12px] leading-snug text-gray-500">
                    Upper and lower arch · occlusion and bite tools
                </p>
            </div>
            <button type="button" onClick={onOpen} className={actionButtonClass('primary')}>
                Open viewer
            </button>
        </section>
    );
}
